import { fromJS } from 'immutable';

export function makeImmutable(val) {
  if (Array.isArray(val) || typeof val === 'object') {
    return fromJS(val);
  }
  return val;
}
